import React from 'react';
import { CheckCircleIcon, LockClosedIcon } from '@heroicons/react/24/outline';
import { useBillingPlans } from '../../hooks/useSubscription';
import { PlanPicker } from './PlanPicker';

/**
 * Post-registration "add a card to start your trial" page. The plan/cadence
 * selection + checkout now live in the shared <PlanPicker/> (also used inline
 * on the dashboard Plan & billing tab); this component just wraps it with the
 * registration chrome.
 */
export const PaymentRequired: React.FC = () => {
  const { data: plansResponse } = useBillingPlans();
  const trialDays = plansResponse?.trial_period_days ?? 14;

  return (
    <div className="auth auth-page">
      <div className="auth-wrap">
        <div className="auth-panel" style={{ marginTop: 0, textAlign: 'center' }}>
          <LockClosedIcon style={{ margin: '0 auto 16px', height: 48, width: 48, color: 'var(--champ)' }} />
          <h1 className="auth-h" style={{ textAlign: 'center' }}>Complete Your Registration</h1>
          <p className="auth-sub" style={{ margin: 0 }}>
            Add your payment information to start your {trialDays}-day free trial
          </p>
        </div>

        <div className="auth-panel" style={{ marginTop: 18 }}>
          <div style={{ display: 'flex', alignItems: 'flex-start' }}>
            <CheckCircleIcon style={{ height: 20, width: 20, color: 'var(--teal-bright)', marginRight: 8, flexShrink: 0 }} />
            <p style={{ fontSize: 13.5, color: 'var(--mute)', margin: 0 }}>
              <strong style={{ color: 'var(--ivory)' }}>Your card will NOT be charged</strong> until your {trialDays}-day
              trial ends. Cancel anytime during the trial.
            </p>
          </div>
        </div>

        <div style={{ marginTop: 18 }}>
          <PlanPicker />
        </div>
      </div>
    </div>
  );
};
